export interface CampaignConfig {
  lp_campaign_id: string
  lp_campaign_key: string
  pd_company_id?: string
}

export const CAMPAIGN_KEYS: Record<string, CampaignConfig> = {
  // Default
  '0': {
    lp_campaign_id: '66280997d0cd2',
    lp_campaign_key: 'zmv8MG2BhD6pJ3QWyLgr',
  },
  // Elise Facebook
  'efb': {
    lp_campaign_id: '695c35f4b5c3b',
    lp_campaign_key: 'p3rFDwKLgJYyQ7vB2Wnc',
  },
  // Justine Facebook
  'jfb': {
    lp_campaign_id: '695c36ad83e5c',
    lp_campaign_key: 'rnC239yBqgzVQfXF6DwN',
  },
}

export function getCampaignConfig(affId: string): CampaignConfig {
  return CAMPAIGN_KEYS[affId] ?? CAMPAIGN_KEYS['0']!
}
